export const css = {
	root: '_2jmwgpKd',
	pressed: 'HC7BjUyO',
	disabled: '_3l-nH32h',
	label: 'fmOlTMfG',
	' _key': 'ascm-theme/ascm/dojo/button'
};

export default css;
